<div class="flex flex-col pt-4 space-y-4">
  <app-section-header
    [title]="pageHeader"
    [isBackBtnShown]="true"
    [backRoute]="['/dashboard']"
    [preserveQueryParam]="true"
  >
    <app-content-state-controls
      *ngIf="initialPageContent"
      [allowableNextStates]="initialPageContent.dynamicData.allowableNextStates"
      [isProcessingStateChange]="isProcessingStateChange"
      [isPublished]="initialPageContent.isPublished()"
      [form]="form"
      [isSaving]="isSaving"
      (handleStateChange)="onUpdateState($event)"
      (handleReEditClick)="createNewVersion()"
      (handleCreateClick)="createNewPage()"
    ></app-content-state-controls>
  </app-section-header>
  <ng-container *ngIf="isProcessing || initialPageContent">
    <app-processing-boundary
      [isProcessing]="isProcessing || !initialPageContent"
      [processingMsg]="'Loading...'"
    >
      <div *ngIf="initialPageContent">
        <app-content-status-card
          [form]="form"
          [formReady]="formReady.asObservable()"
          [content]="initialPageContent"
          [isSaving]="isSaving"
          (handleSave)="onSave()"
          class="px-4"
        ></app-content-status-card>
        <app-content-status-message
          [content]="initialPageContent"
          [contentType]="CONTENT_TYPES.PAGE"
        ></app-content-status-message>
      </div>
      <form
        class="flex p-4 space-x-4"
        [formGroup]="form"
        *ngIf="initialPageContent"
      >
        <div class="flex flex-col flex-1 min-w-0 space-y-4">
          <app-headline-input
            [control]="form.get(FORM_PATHS.HEADLINE())"
          ></app-headline-input>
          <app-standfirst-text
            [control]="form.get(FORM_PATHS.STANDFIRST())"
          ></app-standfirst-text>
          <app-content-editor
            *ngIf="!isProcessing"
            [sectionFormControl]="form.get(FORM_PATHS.BODY())"
            [sectionImgsFormControl]="form.get(FORM_PATHS.IMGS())"
            [sectionVideosFormControl]="form.get(FORM_PATHS.VIDEOS())"
            [isDisabled]="!isEditMode"
            (handleAfterInit)="markAsPristine()"
          ></app-content-editor>
        </div>
        <div class="flex flex-1 min-w-0 pt-1.5 mt-2">
          <mat-accordion [multi]="false" class="flex flex-1 space-x-3">
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-expandable-checkbox-list
                [iconClass]="'icon-globe'"
                [title]="'Websites'"
                [formGroup]="form.get(FORM_PATHS.WEBSITES())"
                [metadata]="deliveryTargets$ | async"
                [isExpandedByDefault]="isNewPage"
                [isExpandable]="isEditMode"
              ></app-expandable-checkbox-list>
            </div>
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-expandable-dropdown
                id="formFieldBodyLanguage"
                [iconClass]="'icon-language'"
                [title]="'Language'"
                [sectionFormControl]="form.get(FORM_PATHS.LANGUAGE())"
                [labelKey]="'FriendlyName'"
                [options]="languages$ | async"
                [defaultOption]="DEFAULT_LANGUAGE_OPTION"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
              ></app-expandable-dropdown>
              <app-internal-information
                [urls]="initialPageContent.dynamicData.liveUrls"
                [contentId]="initialPageContent.contentId"
                [isExpandedByDefault]="false"
              ></app-internal-information>
              <app-version-list
                [versions]="initialPageContent.dynamicData.versions"
                [articleId]="initialPageContent.id"
                [latestPublishedVersionId]="
                  initialPageContent.dynamicData.latestPublishedVersionId
                "
                [latestVersionId]="
                  initialPageContent.dynamicData.latestVersionId
                "
                [isExpandedByDefault]="false"
                [contentType]="CONTENT_TYPES.PAGE"
              ></app-version-list>
              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  !initialPageContent.isPublished() &&
                  initialPageContent.dynamicData.versions.length > 1
                "
                (click)="deleteUnpublishedDraft()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteUnpublishedButton"
              >
                Delete Unpublished Draft
              </button>
              <button
                mat-button
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="!isNewPage"
                (click)="deletePage()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteButton"
              >
                Delete page
              </button>
            </div>
          </mat-accordion>
        </div>
      </form>
    </app-processing-boundary>
  </ng-container>
</div>
